import { render, staticRenderFns } from "./TermsConditionsComponent.vue?vue&type=template&id=734b6bc5&"
import script from "./TermsConditionsComponent.vue?vue&type=script&lang=ts&"
export * from "./TermsConditionsComponent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports